import { Box, Button, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { v4 as uuidv4 } from "uuid";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { sell_nft } from "../../../keychain/login";

import axios from "axios";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  color: 'white',
  display: 'flex',
  flexDirection: {xs: 'column', lg: 'row'}
 
};
export const ViewInventario = ({paginas}) => {
    const { especiales = [], generalNft = [] } = useSelector((state) => state.userSlice);
  
    const {informacion}  = useSelector(state=> state.userSlice)
    const [ barajitas, setBarajita ] = useState([])  
    const [ selector, setSelector ] = useState({})  
    const [open, setOpen] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [precio, setPrecio] = useState('')
    const [idNft, setIdNft] = useState('')
    const [cartas, setCartas] = useState([...especiales, ...generalNft]);
    const getAllCard = async ()=>{
      let data = []
      let bandera = false
      let contador = 0
      do {

        //https://api.primersion.com/contracts/
        //https://custr.de.ryamer.com/contracts/
        const result = await axios.post("https://api.primersion.com/contracts/", {
        jsonrpc: "2.0",
        id: 1,
        method: "find",
        params: {
          contract: "nft",
          table: "NFTHUESOinstances",
          query: { },
          limit: 1000,
          offset: 1000 * contador,
          indexes: [],
        },
      })
      if(result.data?.result?.length > 0){
        contador++
        data = [...result.data?.result, ...data]
      }else{
        bandera = true
        let dataTemp = [...especiales, ...generalNft]
       data.forEach(e=>{
  
   
          if(e?.account !== 'lavino'){
  //console.log(e)
              dataTemp = dataTemp?.map(card=> card?.ide === e?.properties?.ID ? {...card, cantidad: (card?.cantidad ? card?.cantidad : 0) + 1  } : card    )
          }
       })
     
       setCartas(dataTemp)
      }
  
      } while (!bandera);
    
  }
    const handleClose3 = () => {
      setOpen3(false);
    };
    const handleOpen = (card) =>{
      setSelector(card)
      setOpen(true);
    }
    const handleClose = () => setOpen(false);  
    useEffect(()=>{
      let total = []
      getAllCard()
      if(!informacion?.nombre) return
      if(paginas === 2){
          total = especiales
          // [...informacion?.nftEspecial]
      } 
       if(paginas === 1){
          
          total = generalNft
          // [...informacion?.nft]

      }
      setBarajita(total)
  },[paginas])
let nfttotal = [...informacion?.nftEspecial,...informacion?.nft ]
  return (
    <Box sx={{height: '100%', width: '100%'}}>

<Box sx={{background: 'rgba(0,0,0,0.3)',height: '100%', width: '95%', display:'flex', flexWrap: 'wrap', overflow: 'auto'}}>
            {barajitas.map(card=><Box  sx={{position: 'relative', width: '125px',mr:1}}  key={uuidv4()} >
                <Box sx={{position: 'absolute', color: 'white', zIndex:100}}>{card?.id[0] } - {nfttotal?.find(i=>i?.ide === card?.ide)?.cantidad}</Box>
                <Box sx={{position: 'absolute', color: 'red', zIndex:100, right: 5, background: "black"}}>{cartas?.find(i=>i?.ide === card?.ide)?.cantidad}</Box>
                <CardMedia
        onClick={()=>!nfttotal?.find(i=>i?.ide === card?.ide) || handleOpen(nfttotal?.find(i=>i?.ide === card?.ide))}

                sx={{
                  filter:` grayscale(${nfttotal?.find(i=>i?.ide === card?.ide)?.cantidad > 0 ? 0: 1})`, 
                  width: '125px', cursor: 'pointer'}}
                        component="img"
                        image={card?.url}
                        alt="Inicial"/> 
            </Box>
             )}
        </Box>
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{...style, justifyContent: 'center', alignItems: 'center'}}>
      {selector?.ide &&  <Box  sx={{position: 'relative', width: '125px'}}  >
                <Box sx={{  display:'flex',position: 'absolute', color: 'white'}}>{selector?.id[0]} - {selector?.cantidad ? selector?.cantidad :   0}</Box>
                <CardMedia
  

                sx={{width: '125px', cursor: 'pointer'}}
                        component="img"
                        image={selector?.url}
                        alt="Inicial"/> 
            </Box>}
        
       <Box sx={{height: '100px', width: '100%', overflow: 'auto' }}>
        {selector?.nft?.length > 0 && selector?.nft.map(item=>
        <Box key={uuidv4()}  sx={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid gray'}} >
          <Typography>{item}-</Typography>
          <Typography>{selector.id}</Typography>
          <Button onClick={()=>{
            setIdNft(item)
            setOpen3(true)
          }}>Sell</Button>
           </Box>)
}
     
       </Box>
        
       
    
        </Box>
      </Modal>

      <Dialog  open={open3} onClose={handleClose3}>
     
     <DialogContent  sx={{
           background: "#222730",
           width: { xs: "250px", sm: "250px",},
           height: { xs: "200px", sm: "200px" },
           overflow: "Hidden",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           flexDirection: "column",
         }} >
       <DialogContentText sx={{fontSize: '1.3rem', color:'white'}}>
       Select a Price
       </DialogContentText>
       <TextField
         autoFocus
         margin="dense"
         id="name"
         label="Precio"
         type="number"
         fullWidth
         variant="standard"
         onChange={(e)=>{setPrecio(e.target.value)}}
       />
       <DialogActions>
      <Box sx={{display: "flex", flexWrap: "wrap", gap: 2}}>
      <Button 
onClick={()=>{
  if(precio === "")return
  sell_nft(idNft, precio, "VIPHUESO")}}
      > Sell VIPHUESO</Button>
      <Button 
onClick={()=>{
  if(precio === "")return
  sell_nft(idNft, precio, "SWAP.HIVE")}}
      > Sell SWAP.HIVE</Button>
            <Button 
onClick={()=>{
  if(precio === "")return
  sell_nft(idNft, precio, "KOD")}}
      > Sell KOD</Button>
            <Button 
onClick={()=>{
  if(precio === "")return
  sell_nft(idNft, precio, "STARPRO")}}
      > Sell STARPRO</Button>
       <Button onClick={()=>{
       if(precio === "")return

       setOpen3(false)
      sell_nft(idNft, precio, "HUESO")
      }}>Sell HUESO</Button>
      </Box>

    </DialogActions>
     </DialogContent>
     
   </Dialog>
    </Box>
  )
}
